import React from "react";
import AdminCrud from "@/components/AdminCrud";

export default function AdminFAQ() {
  return (
    <AdminCrud
      title="Perguntas Frequentes (FAQ)"
      resource="faqs"
      initialItem={{ status: "published", order: 0 }}
      fields={[
        { name: "question", label: "Pergunta", required: true },
        { name: "answer", label: "Resposta", textarea: true, rows: 5, required: true },
        { name: "order", label: "Ordem", type: "number" },
      ]}
      columns={[
        { name: "question", label: "Pergunta" },
        { name: "order", label: "Ordem" },
      ]}
    />
  );
}
